import React from 'react';
import styled from 'styled-components';
import { 
	string, 
} from 'prop-types';
import {DividerColor,Grey600} from '../../Colors';

const OutlinedTextInputStyle = styled.input.attrs({
	type: 'text'
})`
    appearance: none;
    padding: 5px;
    background: none;
    border-radius: 0;
    outline: none;
    border-radius:5px;
    border: 1px solid ${DividerColor};
    &:hover{
        border: 1px solid ${Grey600};
    }
`;

const UnderlinedTextInputStyle = styled.input.attrs({
	type: 'text'
})`
    appearance: none;
    padding: 5px;
    background: none;
    border-radius: 0;
    outline: none;
    border: none;
    border-bottom: 1px solid ${DividerColor};
    &:hover{
        border-bottom: 1px solid ${Grey600};
    }
`;

const NoOutlinedTextInputStyle = styled.input.attrs({
	type: 'text'
})`
    appearance: none;
    padding: 5px;
    background: none;
    border-radius: 0;
    outline: none;
    border: none;
`;

const TextInput = ({borderType='outlined',...props}) => {
	if(borderType==='outlined'){
		return  <OutlinedTextInputStyle {...props} />;
	}
	else if(borderType==='underlined'){
		return <UnderlinedTextInputStyle {...props} />;
	}
	return <NoOutlinedTextInputStyle {...props} />;
};

TextInput.propTypes = {
	border : string,
	caption : string
    
};

export default  TextInput;